<div class="backIcon">
  <mat-icon class="close-icon" [routerLink]="['/private-space/view-properties']">close</mat-icon>
  <mat-icon class="create-icon" (click)="onEditProperty()" >create</mat-icon>
</div>
<div class="text-center mat-header">
  View Property
</div>
<div class="form-group col-sm-12 text-center" *ngIf="isLoading">
  <img class="loader" src="../../assets/images/loader.gif" width="60px" alt="">
</div>
<mat-card-content *ngIf="!isLoading">
  <form
  [formGroup]="viewPropertyForm"
  class="row g-3 needs-validation"
>
  <div class="form-group col-sm-12">
    <label cLabel for="name">Property Name</label>
    <input class="form-control"
      
      id="name"
      formControlName="name"
      required
      type="text"
      value="Mark"
      readOnly
    />
    
  </div>

  <div class="form-group col-sm-6">
    <label cLabel for="status">Status</label>
    <input class="form-control"
      
    id="status"
    formControlName="status"
    required
    type="text"
    readOnly
  />
    <!-- <select class="form-control"
      id="status"
      formControlName="status"
      required
      readOnly
    >
      <option value="">Choose...</option>
      <option>NEW</option>
      <option>ACTIVE</option>
      <option>INACTIVE</option>
      <option>PUBLISHED</option>
    </select> -->
  </div>

  <div class="form-group col-sm-6">
    <label cLabel for="type">Property Type</label>
    <input class="form-control"
      
      id="type"
      formControlName="type"
      required
      type="text"
      readOnly
    />
  </div>

  <div class="form-group col-sm-12">
    <label cLabel for="industry">industry</label>
    <input class="form-control"
      
      id="industry"
      formControlName="industry"
      required
      type="text"
      readOnly
    />
  </div>

  <div class="form-group col-sm-6">
    <label cLabel for="noOfDays">No. of days</label>
    <input class="form-control"
      
      type="text"
      id="noOfDays"
      name="noOfDays"
      formControlName="noOfDays"
      required
      readOnly
    />
  </div>

  <div class="form-group col-sm-6">
    <label cLabel for="onSiteAttendance">No. site attendance</label>
    <input class="form-control"
      
      type="text"
      id="onSiteAttendance"
      name="onSiteAttendance"
      formControlName="onSiteAttendance"
      required
      readOnly
    />
  </div>

  <div class="form-group col-sm-6">
    <label cLabel for="eventSite">Event Site</label>
    <input class="form-control"
      
      id="eventSite"
      formControlName="eventSite"
      required
      type="text"
      readOnly
    />
  </div>

  <div class="form-group col-sm-6">
    <label cLabel for="category">Category</label>
    <input class="form-control"
      
      id="category"
      formControlName="category"
      required
      type="text"
      readOnly
    />
  </div>

  <div class="form-group col-sm-12">
    <label cLabel for="description">Description</label>
    <!-- <input class="form-control"  id="description" formControlName="description" required type="text"/> -->
    <textarea class="form-control"
      aria-label="Property description"
      
      id="description"
      formControlName="description"
      required
      readOnly
    ></textarea>
  </div>
</form>
</mat-card-content>



